import { useAuth } from "../contexts/useAuth.jsx";
import { useTranslation } from "../contexts/TranslationContext";
import { useNavigate } from "react-router-dom";
import { CircleCheck, CircleX, Key } from "lucide-react";

export default function Profile() {
  const { t } = useTranslation();
  const { email, isPaid, credits } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="flex-1 bg-[#0a0a0a] text-white px-6 pt-12 pb-6">
      <div className="max-w-5xl mx-auto">
        {/* Page Header */}
        <h1 className="text-2xl font-bold text-white mb-6">{t('profile.title')}</h1>

        {/* Account Information */}
        <div className="bg-[#111] border border-white/10 rounded-lg p-6">
            {/* Email */}
            <div className="mb-4">
              <label className="text-sm text-gray-400 mb-1 block">
                {t('profile.email')}
              </label>
              <p className="text-base text-white">{email}</p>
            </div>

            {/* Account Status */}
            <div className="mb-4">
              <label className="text-sm text-gray-400 mb-1 block">
                {t('profile.accountStatus')}
              </label>
              <div>
                {isPaid ? (
                  <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium bg-green-500/10 text-green-400 border border-green-500/20">
                    <CircleCheck size={16} />
                    {t('profile.statusPaid')}
                  </span>
                ) : (
                  <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium bg-gray-500/10 text-gray-400 border border-gray-500/20">
                    <CircleX size={16} />
                    {t('profile.statusFree')}
                  </span>
                )}
              </div>
            </div>

            {/* Credits */}
            <div className="mb-6">
              <label className="text-sm text-gray-400 mb-1 block">
                {t('profile.credits')}
              </label>
              <p className="text-base text-white">
                {t('profile.creditsCount', { count: credits })}
              </p>
            </div>

            {/* Change Password Button */}
            <button
              onClick={() => navigate('/change-password')}
              className="w-full bg-brand-500 hover:bg-brand-400 text-black px-4 py-3 rounded-md font-semibold transition flex items-center justify-center gap-2"
            >
              <Key size={18} />
              {t('profile.changePassword')}
            </button>
        </div>
      </div>
    </div>
  );
}
